// Meta Pixel conversion events. The base pixel (init + PageView) lives in
// public/index.html; this only adds the Purchase event for confirmed orders.

const SENT_KEY = "fb_purchase_sent";
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

function alreadySent(orderNumber) {
  try {
    return (JSON.parse(localStorage.getItem(SENT_KEY)) || []).includes(orderNumber);
  } catch {
    return false;
  }
}

function markSent(orderNumber) {
  try {
    const sent = JSON.parse(localStorage.getItem(SENT_KEY)) || [];
    localStorage.setItem(SENT_KEY, JSON.stringify([...sent, orderNumber].slice(-50)));
  } catch {}
}

// Fire once per order: refreshing the thank-you page or reopening an old
// order link must not count as another sale.
export function trackPurchase(order) {
  if (!order?.orderNumber || typeof window.fbq !== "function") return;
  if (alreadySent(order.orderNumber)) return;
  if (order.createdAt && Date.now() - new Date(order.createdAt) > MAX_AGE_MS) return;

  const items = order.items || [];
  window.fbq(
    "track",
    "Purchase",
    {
      value: Number(order.total) || 0,
      currency: "INR",
      content_type: "product",
      content_ids: items.map((i) => String(i.product?._id || i.product)),
      contents: items.map((i) => ({
        id: String(i.product?._id || i.product),
        quantity: i.quantity,
        item_price: i.price,
      })),
      num_items: items.reduce((s, i) => s + (i.quantity || 0), 0),
    },
    // Lets Meta de-duplicate if a server-side (Conversions API) event is added later
    {eventID: `purchase-${order.orderNumber}`},
  );
  markSent(order.orderNumber);
}
